import { useMemo } from 'react'
import { secure } from '../api'

export class CustomS3Client {
    dirName: string

    constructor(dirName: string) {
        this.dirName = dirName
    }

    fixKey(path: string, file: File): string {
        const fixedFileName = file.name.replace(/[^a-zA-Z0-9.\-_]/g, '_')
        return `${
            this.dirName
        }/${path}/${new Date().getTime()}_${fixedFileName}`
    }

    calculateKey(
        path: string,
        name: string,
        randomPreffix: boolean = true
    ): string {
        const fixedName = name.replace(/[^a-zA-Z0-9.\-_]/g, '_')
        return `${this.dirName}/${path}/${
            randomPreffix ? `${new Date().getTime()}_` : ''
        }${fixedName}`
    }

    async upload(
        key: string,
        file: File | Blob,
        seconds: number = 60,
        tenantId?: string
    ): Promise<any> {
        const secureResponse = await secure({
            key,
            http_method: 'PUT',
            seconds,
            temporal: true,
            tenant_id: tenantId,
        })
        const contentType = file.type || 'text/plain'

        const response = await fetch(secureResponse.url, {
            method: 'PUT',
            headers: {
                'Content-Type': contentType,
            },
            body: file,
        })

        if (response.status === 204 || response.ok) {
            return key
        }
        throw new Error(await response.text())
    }
}

export const loadCustomS3Client = (): CustomS3Client => {
    const dirName: string = process.env.REACT_APP_AWS_S3_DIR ?? ''
    return new CustomS3Client(dirName)
}

export const useS3Client = (): CustomS3Client => {
    const s3Client = useMemo(loadCustomS3Client, [])
    return s3Client
}
